<template>
  <div class="card p-1 mb-3">
    <div class="card-body">
      <h5 class="card-title">Pilih Network</h5>
      <p class="text-light mb-3">
        {{ currency }} tersedia di beberapa jaringan. Pilih network yang ingin
        Anda gunakan.
      </p>
      <select
        class="form-control"
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option value="" disabled>{{ placeholder }}</option>
        <option
          v-for="network in networkOptions"
          :key="network.value"
          :value="network.value"
        >
          {{ network.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { getWalletGroupLabel } from "@/applibs/walletGroupConfig.js";

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    networks: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "-- Pilih Network --",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    networkOptions() {
      return this.networks.map((value) => ({
        value,
        label: getWalletGroupLabel(value),
      }));
    },
  },
};
</script>
